import e from "./Typography.module.js";
import t from "classnames";
import { createElement as n } from "react";
//#region src/components/Typography/Typography.tsx
function r(e, r) {
	return (i) => {
		let [a, { className: o, ...s }] = r(i);
		return n(e, {
			...s,
			className: t(a, o)
		});
	};
}
var i = (n = {}) => {
	let { block: r, small: i, semibold: a, italic: o, secondary: s, error: c } = n;
	return t({
		[e.block]: r,
		[e.small]: i,
		[e.semibold]: a,
		[e.italic]: o,
		[e.secondary]: s,
		[e.error]: c
	});
}, a = (n = {}, r) => t(e.text, i(n), r), o = (e) => {
	let { as: t = "span", block: r, small: i, semibold: o, italic: s, secondary: c, error: l, className: u, ...d } = e;
	return n(t, {
		...d,
		className: a({
			block: r,
			small: i,
			semibold: o,
			italic: s,
			secondary: c,
			error: l
		}, u)
	});
}, s = r("span", ({ bold: n, ...r }) => [t(e.monoText, { [e.monoText_bold]: n }), r]);
//#endregion
export { s as MonoText, o as Text, a as getTextClassName, i as getTextModifierClassName };
